import { NgModule } from '@angular/core';
import { KvmBadgeComponent } from './kvm-badge.component';

@NgModule({
  declarations: [ KvmBadgeComponent ],
  exports: [ KvmBadgeComponent ]
})
export class KvmBadgeModule { }
